// src/components/TablePageSkeleton.tsx
// Premium animated skeleton loader for table-based pages (Institutions & Staff Management).
import Panel from '@/pages/dashboard/components/Panel'

export default function TablePageSkeleton() {
  return (
    <div className="space-y-4 max-w-none px-2 mx-auto pb-10 animate-pulse">
      <Panel
        pad={0}
        className="dash-in overflow-hidden"
        style={{
          backdropFilter: 'none',
          WebkitBackdropFilter: 'none',
          background: 'var(--bg-2)',
          border: '1px solid var(--glass-brd)',
        }}
      >
        {/* Toolbar Skeleton */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 p-4 border-b border-[var(--glass-brd)]">
          {/* Tab segments placeholder */}
          <div className="glass flex p-0.5 rounded-xl gap-0.5 w-[200px] h-[36px] bg-neutral-100/50 dark:bg-neutral-800/20 shrink-0" />

          {/* Search + Action placeholder */}
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full md:w-auto">
            <div className="dash-input w-full sm:w-[220px] bg-neutral-200/50 dark:bg-neutral-800/40 border-none h-[40px] rounded-xl" />
            <div className="w-[110px] h-[40px] rounded-xl bg-neutral-200 dark:bg-neutral-800 shrink-0" />
          </div>
        </div>

        {/* Table Skeleton */}
        <div className="overflow-x-auto">
          <table className="dash-table w-full">
            <thead>
              <tr>
                <th className="py-3 px-4"><div className="h-3 w-16 bg-neutral-200 dark:bg-neutral-800 rounded" /></th>
                <th className="py-3 px-4"><div className="h-3 w-20 bg-neutral-200 dark:bg-neutral-800 rounded" /></th>
                <th className="py-3 px-4"><div className="h-3 w-24 bg-neutral-200 dark:bg-neutral-800 rounded" /></th>
                <th className="py-3 px-4 !text-center"><div className="h-3 w-12 bg-neutral-200 dark:bg-neutral-800 rounded mx-auto" /></th>
                <th className="py-3 px-4 !text-right"><div className="h-3 w-16 bg-neutral-200 dark:bg-neutral-800 rounded ml-auto" /></th>
                <th className="py-3 px-4" />
              </tr>
            </thead>
            <tbody>
              {[...Array(5)].map((_, r) => (
                <tr key={r} className="border-t border-[var(--glass-brd)]">
                  <td className="py-4 px-4">
                    <div className="flex items-center gap-3">
                      <div className="w-9 h-9 bg-neutral-200 dark:bg-neutral-800 rounded-xl" />
                      <div className="space-y-2">
                        <div className="h-4 w-28 bg-neutral-200 dark:bg-neutral-800 rounded" />
                        <div className="h-3 w-36 bg-neutral-200 dark:bg-neutral-800 rounded" />
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-4">
                    <div className="h-4 w-32 bg-neutral-200 dark:bg-neutral-800 rounded" />
                  </td>
                  <td className="py-4 px-4">
                    <div className="flex gap-1.5">
                      <div className="h-5 w-16 bg-neutral-200 dark:bg-neutral-800 rounded-lg" />
                      <div className="h-5 w-12 bg-neutral-200 dark:bg-neutral-800 rounded-lg" />
                    </div>
                  </td>
                  <td className="py-4 px-4">
                    <div className="h-5 w-16 mx-auto bg-neutral-200 dark:bg-neutral-800 rounded-full" />
                  </td>
                  <td className="py-4 px-4">
                    <div className="h-4 w-20 ml-auto bg-neutral-200 dark:bg-neutral-800 rounded" />
                  </td>
                  <td className="py-4 px-4">
                    <div className="h-4 w-4 ml-auto bg-neutral-200 dark:bg-neutral-800 rounded" />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Panel>
    </div>
  )
}
